import * as React from "react"

function Invoice(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#prefix__clip0)" >
        <path stroke="none" d="M23.744 14.129L21.664 12l2.08-2.129a.863.863 0 000-1.186l-2.08-2.129 2.08-2.129a.813.813 0 00.17-.919.82.82 0 00-.775-.508H1.849a.82.82 0 00-.775.508c-.12.315-.072.677.17.92l2.08 2.128-2.08 2.13a.863.863 0 000 1.185L3.324 12l-2.08 2.129a.863.863 0 000 1.186l2.08 2.129-2.08 2.129a.813.813 0 00-.17.919.819.819 0 00.775.508h21.29a.82.82 0 00.774-.508c.121-.315.073-.678-.17-.92l-2.08-2.128 2.08-2.13c.315-.314.315-.846 0-1.185zm-3.871 2.734a.863.863 0 000 1.185l1.258 1.283H3.857l1.258-1.283a.863.863 0 000-1.185l-2.08-2.13 2.08-2.128a.863.863 0 000-1.186L3.035 9.29l2.08-2.129a.863.863 0 000-1.185L3.857 4.694H21.13l-1.258 1.258a.863.863 0 000 1.185l2.08 2.13-2.08 2.128a.863.863 0 000 1.186l2.08 2.129-2.08 2.153z" />
        <path stroke="none" d="M12.856 11.129h-.726a.788.788 0 01-.556-.242.743.743 0 01-.194-.58c.049-.388.387-.678.823-.678h.847c.217 0 .411.145.46.363.048.169.193.314.386.314h.992a.4.4 0 00.29-.12c.073-.073.122-.194.097-.291a2.186 2.186 0 00-1.887-1.96v-.798a.382.382 0 00-.387-.387h-.967a.382.382 0 00-.388.387v.75a2.535 2.535 0 00-2.008 2.71c.121 1.282 1.283 2.274 2.613 2.274h.63c.217 0 .41.096.556.242.145.169.218.363.193.604-.048.388-.411.702-.822.702h-.847a.466.466 0 01-.46-.363.392.392 0 00-.387-.29h-.992a.4.4 0 00-.29.12c-.073.073-.097.194-.097.291a2.186 2.186 0 001.887 1.96v.798c0 .218.17.387.387.387h.968c.218 0 .387-.169.387-.387v-.822a2.57 2.57 0 002.008-2.202 2.471 2.471 0 00-.653-1.935c-.46-.557-1.161-.847-1.863-.847z" />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

const MemoInvoice = React.memo(Invoice);
export default MemoInvoice;
